import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-data-protection',
  templateUrl: './data-protection.page.html',
  styleUrls: ['./data-protection.page.scss'],
})
export class DataProtectionPage implements OnInit, OnDestroy {

  /**
   * Constructor
   * @param router router
   */
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
      
  }

  ngOnDestroy(): void {
      
  }

  /**
   * Go about home page
   */
  goAboutHomePage() {
    this.router.navigate(['/about/home']);
  }
}
